import { BackContainer } from "../../../types";
import Container, { EmptyContainer } from "../../meta-container";
import { ActivityPopupMeta } from "../types";
import { CashDeleteActivityPopup } from "./cash-delete-activity";
import { CashRecvActivityPopup } from "./cash-recv-activity";
import CashSpendActivityPopup from "./cash-spend-activity/CashSpendActivityPopup";
import { CashUpdateActivityPopup } from "./cash-update-activity";
import { CashActivity, CashActivityAction, CashActivityData } from "./types";

const CashActivityPopupRenderer = <T extends {}>(
  props: ActivityPopupMeta<T>
) => {
  const activity = props.data as CashActivity;
  return (
    <Container<CashActivityAction, BackContainer<CashActivityData, T>>
      data={{ data: activity.data, back: props.back }}
      type={activity.action}
      match={{
        [CashActivityAction.None]: EmptyContainer,
        [CashActivityAction.Recv]: CashRecvActivityPopup,
        [CashActivityAction.Spend]: CashSpendActivityPopup,
        [CashActivityAction.Update]: CashUpdateActivityPopup,
        [CashActivityAction.Delete]: CashDeleteActivityPopup,
      }}
    />
  );
};

export default CashActivityPopupRenderer;
